import { SharedCertificateForm } from "./SharedCertificateForm";
interface CertificatePageProps {
    spaceId: string;
    certificateId: string;
}
export function CertificatePage({ spaceId, certificateId }: CertificatePageProps) {
    return <SharedCertificateForm spaceId={spaceId} certificateId={certificateId} create={false}/>;
}
